import React from "react";
import { useProgress } from "@react-three/drei";

export const LazyCanvasLoader = () => {
    const { progress } = useProgress();

    return (
        <div
            style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "2px",
                zIndex: 9999,
                background: "transparent",
            }}
        >
            <div
                style={{
                    height: "100%",
                    width: `${progress}%`,
                    background: "#BB0E1F",
                    transition: "width 0.2s ease-out",
                }}
            />
        </div>
    );
};
